import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';

/** The table's own filters, from its `filters` config. */
export function FiltersPopoverContent() {
  const { table } = useTiclickTableContext();

  const Filters = table.options.meta?.filters;

  return (
    <div className='flex flex-col'>
      <div className='space-y-4'>{Filters && <Filters />}</div>
    </div>
  );
}
